<template>
	<v-btn v-bind="$attrs" v-on="$listeners" :class="[small ? 'small-button' : 'icon-button']" depressed>
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'IconButton',
	props: {
		small: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.icon-button {
	padding: 0 10px !important;
	border: var(--primary-border);
	background: transparent !important;
}
.small-button {
	min-height: 20px;
	max-height: 20px;
	padding: 0px 0px !important;
	border: var(--primary-border);
}
</style>
